import { render } from "./FullReportTableCallerNumbers.vue?vue&type=template&id=88ef507a&scoped=true"
import script from "./FullReportTableCallerNumbers.vue?vue&type=script&lang=js"
export * from "./FullReportTableCallerNumbers.vue?vue&type=script&lang=js"

import "./FullReportTableCallerNumbers.vue?vue&type=style&index=0&id=88ef507a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ef507a"]])

export default __exports__